module.exports = __webpack_public_path__ + "img/repair-disabled.9393bd6b.svg";